/* GENERATED FILE - do not edit. Run: node scripts/generate-phosphor-icons.mjs */
import type { JSX } from 'solid-js'
import { IconBase, type IconProps, type WeightRenderers } from './IconBase'

const renderers: WeightRenderers = {
  regular: (color: string): JSX.Element => (
    <g>
      <polyline
        points="160 208 80 128 160 48"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      />
    </g>
  ),
}

export const CaretLeft = (props: IconProps) => <IconBase {...props} renderers={renderers} />
